// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/img/logos/kubernetes-generic-logo-icon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.menu .eWfM8{line-height:normal}.eWfM8 .lHHaQ{align-items:center;display:flex;justify-content:space-between;line-height:1}.eWfM8 .lHHaQ .T2o0G{align-items:center;display:inline-flex;line-height:1;margin:0;white-space:nowrap}.eWfM8 .lHHaQ .T2o0G .kXaLv{color:#767676;font-size:1.4rem;margin-right:1.25rem}.eWfM8 .lHHaQ .T2o0G .kXaLv.active{color:#127d78}.eWfM8 .lHHaQ .T2o0G .kXaLv.bugbO{color:inherit}.eWfM8 .lHHaQ .T2o0G .kXaLv.pVbY8{background:currentcolor;height:1.4rem;margin-bottom:-.25rem;-webkit-mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:100%;mask-size:100%}.eWfM8 .lHHaQ .EqThM._TI1t{font-size:.85rem;left:2.3rem;position:absolute;top:.6rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `eWfM8`,
	"wrapper": `lHHaQ`,
	"inner": `T2o0G`,
	"icon": `kXaLv`,
	"disabled": `bugbO`,
	"kubeIcon": `pVbY8`,
	"suffix": `EqThM`,
	"mini": `_TI1t`
};
module.exports = ___CSS_LOADER_EXPORT___;
